import type { NavLink, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Cortex',
    description: 'Cortex designs and deploys AI agents, digital workflows and intelligent business systems that automate operations, accelerate execution and help organizations scale with confidence.',
    url: getOrigin(),
    email: 'hello@cortex.ai',
    ogImage: 'https://cortex.cdn.modulify.website/images/share/cortex-share.png'
}

export const NAV_LINKS: NavLink[] = [
    { label: 'About', href: '/about' },
    { label: 'Solutions', href: '/solutions' },
    { label: 'Services', href: '/services' },
    { label: 'Case Studies', href: '/case-studies' },
    { label: 'Contact', href: '/contact' }
]

export const PRIMARY_CTA: NavLink = {
    label: 'Book a consultation',
    href: '/contact'
}
